/**
 * routers
 * 更多关于Router的使用，请参考以下教程
 * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
 */

// 人力资源
import { Form } from 'antd';
import OrgIndex from './org/Index';
import WorkOrgIndex from './workorg/Index';

import StaffIndex from './staff/Index';

import WageIndex from './wageImport/Index';
import WageMine from './wage/PageMine';
import WageWatch from './wage/PageWatch';
import WageAdd from './wage/PageAdd';
import WageOpen from './wage/PageInfo';
import WageStatic from './wage/PageStatic';
import PageMonthCompany from './wage/PageMonthCompany';
import PageYearCompany from './bonus/PageYearCompany';
import WageDetail from './wage/PageDetail';
// 年终奖
import BonusAdd from './bonus/PageAdd';
import BonusMine from './bonus/PageMine';
import BonusWatch from './bonus/PageWatch';
import BonusOpen from './bonus/PageInfo';
import BonusDetail from './bonus/PageDetail';

const router = {
  path: 'hr',
  breadcrumbName: '人力资源',
  childRoutes: [
    {
      path: 'org',
      breadcrumbName: '组织架构',
      indexRoute: { component: OrgIndex },
    },
    {
      path: 'workorg',
      breadcrumbName: '业务部门管理',
      indexRoute: { component: WorkOrgIndex },
    },
    {
      path: 'staff',
      breadcrumbName: '人员列表',
      indexRoute: { component: StaffIndex },
    },
    {
      path: 'wage',
      breadcrumbName: '工资导入',
      indexRoute: { component: WageIndex },
      childRoutes: [
        {
          path: 'detail/:uuid',
          component: WageDetail,
          breadcrumbName: '工资明细',
        },
        {
          path: 'wageCompanyMonth/:uuid',
          component: Form.create({ wrappedComponentRef: true })(PageMonthCompany),
          breadcrumbName: '工资查看',
        },
        {
          path: 'bonusCompanyYear/:uuid',
          component: Form.create({ wrappedComponentRef: true })(PageYearCompany),
          breadcrumbName: '年终奖查看',
        },
      ],
    },
    {
      path: 'w_static',
      breadcrumbName: '公司薪酬总览',
      indexRoute: { component: WageStatic },
    },
    {
      path: 'w_manage',
      breadcrumbName: '我的工资',
      indexRoute: { component: WageMine },
      childRoutes: [
        {
          path: 'add',
          component: WageAdd,
          breadcrumbName: '工资申请',
        },
        {
          path: 'open/:uuid',
          component: WageOpen,
          breadcrumbName: '查看工资',
        },
      ],
    },
    {
      path: 'w_manage_watch',
      breadcrumbName: '工资监控',
      indexRoute: { component: WageWatch },
    },
    {
      path: 'b_manage',
      breadcrumbName: '我的年终奖',
      indexRoute: { component: BonusMine },
      childRoutes: [
        {
          path: 'detail/:uuid',
          component: BonusDetail,
          breadcrumbName: '年终奖明细',
        },
        {
          path: 'add',
          component: BonusAdd,
          breadcrumbName: '年终奖申请',
        },
        {
          path: 'open/:uuid',
          component: BonusOpen,
          breadcrumbName: '查看年终奖',
        },
      ],
    },
    {
      path: 'b_manage_watch',
      breadcrumbName: '年终奖监控',
      indexRoute: { component: BonusWatch },
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/hr/router.js